import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
  
export default new Vuex.Store({
  state: {
    select: {
      user: {
        data: null
      },
      breed: {
        data: null
      },
      dog: {
        id: null,
        data: null
      },
    }
  },
  getters: {
    _user(state){
      return state.select.user
    },
    _breed(state){
      return state.select.breed
    },
    _dog(state){
      return state.select.dog
    },
  },
  mutations: {
    SET_SEL_USER(state, data) {
      state.select.user = data;      
    },
    SET_SEL_BREED(state, data) {
      state.select.breed.data = data;   
    },
    SET_SEL_DOG(state, data) {
      state.select.dog = data;  
    }
  },
});